import classnames from 'classnames';
import type { FC } from 'react';

import { Text } from '@/core/tamagoshi/Text/Text';
import { useMassLandings } from '@/domains/productDiscovery/ProductPage/b2c/components/MassLandings/hooks/useMassLandings';

import { massLandingsTitle } from './translations';

import styles from './masslandings.module.scss';

interface Props {
  className?: string;
}

export const MassLandings: FC<Props> = ({ className }) => {
  const massLandings = useMassLandings();

  if (massLandings == null || massLandings.length === 0) return null;

  return (
    <div
      data-testid="MassLandings"
      className={classnames(styles.container, className)}
    >
      <Text tag="h2" type="h4" weight="bold" className={styles.title}>
        {massLandingsTitle}
      </Text>
      <ul className={styles.list}>
        {massLandings.map(({ url, name }) => (
          <li key={url} className={styles.tag}>
            <a href={url} data-testid="massLandings-link">
              {name}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};

MassLandings.displayName = 'MassLandings';
